import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    login(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/auth/sign_in', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUsers(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/users', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/users/${params.id}`, { params })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateUser(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/users/${params.id}`, params)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    verify(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`api/v1/users/${params.id}/verify`, { params })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    logoutActivity(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/user_activities/logout', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    reprintActivity(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/user_activities/reprint', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUserActivities(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/user_activities', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAccessProducts(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/variables/access_products', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}